import { Grid, CardOverflow, AspectRatio } from "@mui/joy";

function NewsImage({ imageUrl, title }) {
  return (
    <Grid xs={12} md={3}>
      <CardOverflow sx={{ borderRadius: "16px", m: 1, overflow: "hidden", height: "100%" }}>
        <AspectRatio ratio="1/1" sx={{ minHeight: "120px" }}>
          <img
            src={imageUrl}
            alt={title}
            loading="lazy"
            style={{ objectFit: "cover", borderRadius: "12px" }}
          />
        </AspectRatio>
      </CardOverflow>
    </Grid>
  );
}

export default NewsImage;